import React from 'react'
import {connect} from 'react-redux'
import TabContent from '../../components/Monitoring/TabContent'
import { receiveMonitoringData } from '../../actions/statusesActions'

const mapStateToProps = (state) => {
  return {
    monitoringData: state.adminStatuses.monitoring
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveMonitoringData: (data) => {
      dispatch(receiveMonitoringData(data))
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(TabContent)


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/containers/Monitoring/TabContentContainer.jsx